import React from "react";
import PropTypes from "prop-types";

import WdSelect from "../../shared_components/wd_select";
import FormStrings from "../utils/form_strings";
import ViewAndFilterHelpers from "../utils/view_and_filter_helpers";

class PrimaryFilter extends React.Component {
  multi = true

  onTypeChange = (e) => {
    const typeObj = ViewAndFilterHelpers.filterFromId(this.props.filterObjects, e.value);
    this.props.onTypeChange(typeObj);

    this.props.onUpdate();
  }

  onOptionsChange = (e) => {
    this.props.onOptionsChange(e);

    this.props.onUpdate();
  }

  render() {
    const types = this.props.filterObjects.map((e) => ({ value: e.id, label: e.name }));
    const selectedType = ViewAndFilterHelpers.filterFromId(this.props.filterObjects, this.props.selectedTypeId);
    let options;

    if (selectedType) {
      options = selectedType.js_options;
    }

    if (options) options = options.map((e) => ({ value: e, label: e}));

    const disabled = !options;

    const display = disabled ? "none" : "block";

    const multi = this.multi;

    const viewType = ViewAndFilterHelpers.viewFromId(this.props.viewObjects, this.props.selectedViewTypeId) || {};
    const desalTroubleViewType = viewType.label === "CAPEX - Regions" || viewType.label === "CAPEX - Technologies";
    const applicationPrimaryFilter = selectedType && selectedType.name === "Application";

    const disableOption = (e) => {
      return desalTroubleViewType && applicationPrimaryFilter && e.label === "Seawater and brackish water desalination";
    };

    const optionsWithSomeDisables = (options || []).map((e) => ({ isDisabled: disableOption(e), value: e.value, label: e.label }));

    return (
      <div>
        <h4>Primary scope</h4>
        <WdSelect
          value={types.find(t => t.value === this.props.selectedTypeId) || null}
          name={FormStrings.primaryFilterTypeName}
          options={types}
          onChange={this.onTypeChange}
          isClearable={false}
          />

        <WdSelect
          name={FormStrings.primaryFilterOptionName(this.multi)}
          onChange={this.onOptionsChange}
          // `|| null` — react-select v5 treats an undefined `value` as UNCONTROLLED
          // and keeps its internal chips when the reducer resets primaryFilter on a
          // scope change (same trap as secondary_filters.js).
          value={this.props.selectedOptions || null}
          options={optionsWithSomeDisables}
          isDisabled={disabled}
          style={{ "display": display }}
          isMulti={multi}
          />
      </div>
    );
  }
}

PrimaryFilter.propTypes = {
  filterObjects: PropTypes.arrayOf(PropTypes.object),
  viewObjects: PropTypes.arrayOf(PropTypes.object),
  onTypeChange: PropTypes.func.isRequired,
  onOptionsChange: PropTypes.func.isRequired,
  selectedTypeId: PropTypes.string,
  selectedOptions: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.object),
  ]),
  onUpdate: PropTypes.func.isRequired,
  selectedViewTypeId: PropTypes.number
};

export default PrimaryFilter;
